import colors from '../colors'

export const accordionTheme = {
  border: colors.gray[4],
  panelBackground: colors.gray[3],
  sizes: {
    sm: {
      fontSize: `0.875em`,
      margin: `0.5em`
    },
    md: {
      fontSize: `1em`,
      margin: `0.5em`
    },
    lg: {
      fontSize: `1em`,
      margin: `0.625em`
    }
  }
}
